// extracted by mini-css-extract-plugin
export default {"button":"themeToggle-module__button___yoBaI","image":"themeToggle-module__image___Wonv0"};